var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiscard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05157 8.48439H5.27657V11.4844C5.24487 11.6886 5.26179 11.8975 5.32596 12.0939C5.39013 12.2904 5.49974 12.4689 5.64588 12.6151C5.79202 12.7612 5.97058 12.8708 6.16704 12.935C6.36351 12.9992 6.57234 13.0161 6.77657 12.9844C6.88148 12.9771 6.98144 12.937 7.06223 12.8697C7.14302 12.8024 7.20053 12.7113 7.22657 12.6094L9.00757 6.98439L9.00757 0.984389H2.57657C2.09966 0.99362 1.6416 1.17224 1.28434 1.48828C0.92707 1.80432 0.693909 2.23717 0.626569 2.70939L0.0265684 6.15939C-0.020647 6.43886 -0.00473976 6.72535 0.0731239 6.99787C0.150988 7.2704 0.288836 7.52205 0.476568 7.73439C0.65919 7.97711 0.897791 8.17207 1.17203 8.30266C1.44628 8.43325 1.74803 8.4956 2.05157 8.48439Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0076 6.98438H12.0076V0.984375H10.0076V6.98438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscard);
export default __webpack_public_path__ + "static/media/icon_discard.55a65eb9.svg";
export { ForwardRef as ReactComponent };